import apiClient from "./axios";
import { ApiResponse } from "../types";

export interface Agent {
  key: string;
  name: string;
  description: string;
  isPremium: boolean;
  isEnabled: boolean;
  contextTypes: string[];
}

export const agentsApi = {
  getAgents: async () => {
    const { data } = await apiClient.get<ApiResponse<Agent[]>>("/admin/agents");
    return data.data;
  },

  toggleAgent: async (key: string, isEnabled: boolean) => {
    const { data } = await apiClient.patch<ApiResponse<Agent>>(
      `/admin/agents/${key}/toggle`,
      { isEnabled },
    );
    return data.data;
  },
};
